export const REQUEST_GET_ALL_DOCUMENTS = 'documents/REQUEST_GET_ALL_DOCUMENTS';
export const RECEIVED_ALL_DOCUMENTS = 'documents/RECEIVED_ALL_DOCUMENTS';
export const REQUEST_UPLOAD_DOCUMENT = 'documents/REQUEST_UPLOAD_DOCUMENT';
export const DOCUMENT_UPLOADED_SUCCESSFULLY = 'documents/DOCUMENT_UPLOADED_SUCCESSFULLY';
export const REQUEST_UPDATE_DOCUMENT = 'documents/REQUEST_UPDATE_DOCUMENT';
export const DOCUMENT_UPDATED_SUCCESSFULLY = 'documents/DOCUMENT_UPDATED_SUCCESSFULLY';
export const REMOVE_ALL_DOCUMENTS = 'documents/REMOVE_ALL_DOCUMENTS';

export const RECEIVED_ERROR = 'documents/RECEIVED_ERROR';